import React, { createContext, useContext, useReducer } from 'react';
import { Proposal } from '@/interfaces/types';
import { OtherData } from '@/interfaces/types';
import {
  proposalReducer,
  initialProposalState,
  PROPOSALACTIONS,
} from '../reducers/proposalReducer';
import {
  userFeedbackReducer,
  initialUserFeedbackState,
  USERFEEDBACKACTIONS,
} from '../reducers/userFeedbackReducer';
import {
  otherDataReducer,
  initialOtherState,
  OTHERDATAACTIONS,
} from '../reducers/otherDataReducer';

interface ProposalContextType {
  proposal: Proposal;
  dispatchProposal: React.Dispatch<any>;
  userFeedback: typeof initialUserFeedbackState;
  dispatchUserFeedback: React.Dispatch<any>;
  otherData: OtherData;
  dispatchOtherData: React.Dispatch<any>;
}

const ProposalContext = createContext<ProposalContextType | undefined>(undefined);

export function ProposalProvider({ children }: { children: React.ReactNode }) {
  const [proposal, dispatchProposal] = useReducer(proposalReducer, initialProposalState);
  const [userFeedback, dispatchUserFeedback] = useReducer(
    userFeedbackReducer,
    initialUserFeedbackState
  );
  const [otherData, dispatchOtherData] = useReducer(otherDataReducer, initialOtherState);

  return (
    <ProposalContext.Provider
      value={{
        proposal,
        dispatchProposal,
        userFeedback,
        dispatchUserFeedback,
        otherData,
        dispatchOtherData,
      }}
    >
      {children}
    </ProposalContext.Provider>
  );
}

export function useProposal() {
  const context = useContext(ProposalContext);
  if (context === undefined) {
    throw new Error('useProposal must be used within a ProposalProvider');
  }
  return context;
}

// Export action types for convenience
export { PROPOSALACTIONS, USERFEEDBACKACTIONS, OTHERDATAACTIONS };
